const MIGIPEDIA_THEME_IDS = ['migipedia', 'migipediaDark'];
export const isMigipediaTheme = themeId => MIGIPEDIA_THEME_IDS.includes(themeId);
export const isMigipediaDarkTheme = themeId => themeId === 'migipediaDark';